import * as Yup from "yup";
import { actions as filesActions, selectors as filesSelectors } from "@containers/SensorDataFile/store";
import { FORM_ERROR_MESSAGES } from "@shared/constants";
import { SensorDataFile } from "@shared/models";
import { OptionWithData } from "@shared/interfaces";

export const selectFileValidationSchema = Yup.object().shape({
  files: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED),
        label: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED),
      }),
    )
    .min(1, FORM_ERROR_MESSAGES.REQUIRED),
});

export const getInitValues = (): { files: OptionWithData<SensorDataFile>[] } => {
  return {
    files: [],
  };
};

export const handlers = {
  files: {
    getData: (search: string) =>
      filesActions.getSensorDataFiles.request({
        search,
        page: 0,
        limit: 20,
        is_original: true,
      }),
    selectData: filesSelectors.getSensorDataFiles,
    prepareOptionFunction: (item: SensorDataFile): OptionWithData<SensorDataFile> => {
      return { label: item.name, value: String(item.id), data: item };
    },
  },
};
